<template>
	<div class="news-global">
		<div class="global-con">
			<div class="title">
				<i class="x-icon-news"></i><span class="x-tit-con">Footprints Worldwide</span>
			</div>

			<div class="content">
				<div class="visible">
					<p>
						Xhorse never stops its steps to get more great opportunities for growth. The on-going development of Xhorse can be demonstrated by technology-driven innovation. While devoting itself to keep up with the latest globalization tendency of science and technology, At the same time, Xhorse adheres to cooperate with more partners and will be dedicated to providing better security solutions for all the Xhorse users worldwide.</p>

					<img :src="newImage_01" alt="Xhorse"/>

					<ul>
						<li>
							<router-link to="">
								<img :src="newImage_02" alt="Xhorse"/>
								<div class="hit">Argentina</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_03" alt="Xhorse"/>
								<div class="hit">Australia</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_04" alt="Xhorse"/>
								<div class="hit">Czech Republic</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_05" alt="Xhorse"/>
								<div class="hit">Dubai</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_06" alt="Xhorse"/>
								<div class="hit">Germany</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_07" alt="Xhorse"/>
								<div class="hit">India</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_08" alt="Xhorse"/>
								<div class="hit">Korea</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_09" alt="Xhorse"/>
								<div class="hit">Malaysia</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_10" alt="Xhorse"/>
								<div class="hit">Spain</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_11" alt="Xhorse"/>
								<div class="hit">Thailand</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_12" alt="Xhorse"/>
								<div class="hit">The UK</div>
							</router-link>
						</li>
						<li>
							<router-link to="">
								<img :src="newImage_13" alt="Xhorse"/>
								<div class="hit">The USA</div>
							</router-link>
						</li>

					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import newImage_01 from '@/assets/resource/images/news/image_news_01.png'
    import newImage_02 from '@/assets/resource/images/news/image_news_over_01.png'
    import newImage_03 from '@/assets/resource/images/news/image_news_over_02.png'
    import newImage_04 from '@/assets/resource/images/news/image_news_over_03.png'
    import newImage_05 from '@/assets/resource/images/news/image_news_over_04.png'
    import newImage_06 from '@/assets/resource/images/news/image_news_over_05.png'
    import newImage_07 from '@/assets/resource/images/news/image_news_over_06.png'
    import newImage_08 from '@/assets/resource/images/news/image_news_over_07.png'
    import newImage_09 from '@/assets/resource/images/news/image_news_over_08.png'
    import newImage_10 from '@/assets/resource/images/news/image_news_over_09.png'
    import newImage_11 from '@/assets/resource/images/news/image_news_over_10.png'
    import newImage_12 from '@/assets/resource/images/news/image_news_over_11.png'
    import newImage_13 from '@/assets/resource/images/news/image_news_over_12.png'
    export default {
        props: ['activeSideIndex', 'activeTopIndex'],
        data(){
            return {
                newImage_01: newImage_01,
                newImage_02: newImage_02,
                newImage_03: newImage_03,
                newImage_04: newImage_04,
                newImage_05: newImage_05,
                newImage_06: newImage_06,
                newImage_07: newImage_07,
                newImage_08: newImage_08,
                newImage_09: newImage_09,
                newImage_10: newImage_10,
                newImage_11: newImage_11,
                newImage_12: newImage_12,
                newImage_13: newImage_13,
            };
        },
        methods: {
            goWhere(supportId, event){
                const _this = this;
                _this.$emit('go', {type: 'side', val: ["4"]})
                console.log(supportId, event)
            }
        }
    }

</script>

<style scoped>
	.visible > ul > li > a > .hit {
		width: 100%;
		height: 1rem;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: center;
		line-height: 1rem;
		margin-top: 1rem;
	}

	.visible > ul > li > a > img {
		outline: none;
		border: none;
		width: 100%;
	}

	.visible > ul > li > a {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
	}

	.visible > ul > li:nth-child(3n-1) {
		margin-left: 1rem;
		margin-right: 1rem;
	}

	.visible > ul > li {
		width: calc((100% - 2rem) / 3);
		height: 12rem;
		border: none;
		float: left;
		margin-bottom: 2rem;
	}

	.visible > ul {
		width: 100%;
		height: 54rem;
		margin-top: 2.75rem;
		border: none;
	}

	.visible > img {
		width: 100%;
		margin-top: 4rem;
	}

	.visible > p {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.content > .visible {
		width: 100%;
		border: none;
		height: 100%;
	}

	.content {
		width: 54.5rem;
		margin-left: 7rem;
		border: none;
	}

	.global-con > .title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.global-con {

		width: 61.5rem;
		height: 103.125rem;

	}

	.title > .x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.x-icon-news {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_news.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.news-global {
		width: 100%;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/news/news-global.vue